import {
  GET_CUSTOMERS_REQUEST,
  GET_CUSTOMERS_SUCCESS,
  GET_CUSTOMERS_FAILURE,
  GET_CUSTOMER_LINEITEMS_LOOKUP_REQUEST,
  GET_CUSTOMER_LINEITEMS_LOOKUP_SUCCESS,
  GET_CUSTOMER_LINEITEMS_LOOKUP_FAILURE,
  GET_CUSTOMER_ADDRESSES_REQUEST,
  GET_CUSTOMER_ADDRESSES_SUCCESS,
  GET_CUSTOMER_ADDRESSES_FAILURE,
  ADD_UPDATE_CUSTOMER_LINE_ITEM_REQUEST,
  ADD_UPDATE_CUSTOMER_LINE_ITEM_SUCCESS,
  ADD_UPDATE_CUSTOMER_LINE_ITEM_FAILURE,
  ADD_UPDATE_CUSTOMER_ADDRESS_REQUEST,
  ADD_UPDATE_CUSTOMER_ADDRESS_SUCCESS,
  ADD_UPDATE_CUSTOMER_ADDRESS_FAILURE,
  ADD_UPDATE_CUSTOMER_DETAILS_REQUEST,
  ADD_UPDATE_CUSTOMER_DETAILS_SUCCESS,
  ADD_UPDATE_CUSTOMER_DETAILS_FAILURE,
} from "./actionTypes";
import { CustomerState } from "./types";

const initialState: CustomerState = {
  customers: [],
  loadingScreen: false,
  loadingLineItemsLookup: false,
  loadingCustomerAddresses: false,
  error: null,
  successMessage: "",
  pending: false,
  customerReferences: [],
  customerLineItems: [],
  customerAddresses: [],
  lineItemsLookupCustomerId: null,
  addressesCustomerId: null,
};

const settingsReducer = (state = initialState, action: any): CustomerState => {
  switch (action.type) {
    case GET_CUSTOMERS_REQUEST:
      return {
        ...state,
        loadingScreen: true,
        error: null,
      };
    case GET_CUSTOMERS_SUCCESS:
      return {
        ...state,
        loadingScreen: false,
        customers: action.payload.customers,
      };
    case GET_CUSTOMERS_FAILURE:
      return {
        ...state,
        loadingScreen: false,
        error: action.error,
      };
    case GET_CUSTOMER_LINEITEMS_LOOKUP_REQUEST:
      return {
        ...state,
        loadingLineItemsLookup: true,
        error: null,
      };
    case GET_CUSTOMER_LINEITEMS_LOOKUP_SUCCESS:
      return {
        ...state,
        loadingLineItemsLookup: false,
        customerLineItems: action.payload.customerLineItems,
        lineItemsLookupCustomerId: action.payload.customerId,
      };
    case GET_CUSTOMER_LINEITEMS_LOOKUP_FAILURE:
      return {
        ...state,
        loadingLineItemsLookup: false,
        error: action.error,
      };
    case GET_CUSTOMER_ADDRESSES_REQUEST:
      return {
        ...state,
        loadingCustomerAddresses: true,
        error: null,
      };
    case GET_CUSTOMER_ADDRESSES_SUCCESS:
      return {
        ...state,
        loadingCustomerAddresses: false,
        customerAddresses: action.payload.customerAddresses,
        addressesCustomerId: action.payload.customerId,
      };
    case GET_CUSTOMER_ADDRESSES_FAILURE:
      return {
        ...state,
        loadingCustomerAddresses: false,
        error: action.error,
      };
    case ADD_UPDATE_CUSTOMER_LINE_ITEM_REQUEST:
      return {
        ...state,
        pending: true,
        error: null,
      };
    case ADD_UPDATE_CUSTOMER_LINE_ITEM_SUCCESS:
      return {
        ...state,
        pending: false,
        successMessage: action.payload.successMessage,
      };
    case ADD_UPDATE_CUSTOMER_LINE_ITEM_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case ADD_UPDATE_CUSTOMER_ADDRESS_REQUEST:
      return {
        ...state,
        pending: true,
        error: null,
      };
    case ADD_UPDATE_CUSTOMER_ADDRESS_SUCCESS:
      return {
        ...state,
        pending: false,
        successMessage: action.payload.successMessage,
      };
    case ADD_UPDATE_CUSTOMER_ADDRESS_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case ADD_UPDATE_CUSTOMER_DETAILS_REQUEST:
      return {
        ...state,
        pending: true,
        error: null,
      };
    case ADD_UPDATE_CUSTOMER_DETAILS_SUCCESS:
      return {
        ...state,
        pending: false,
        successMessage: action.payload.successMessage,
      };
    case ADD_UPDATE_CUSTOMER_DETAILS_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default settingsReducer;
